import { fileTypeLabel } from "../lib/format";

const MAP = {
  PDF: { bg: "#FEF2F2", fg: "#991B1B", bd: "#FCA5A5" },
  PPT: { bg: "#FFF7ED", fg: "#C2410C", bd: "#FDBA74" },
  PPTX: { bg: "#FFF7ED", fg: "#C2410C", bd: "#FDBA74" },
  DOC: { bg: "#EFF6FF", fg: "#1D4ED8", bd: "#93C5FD" },
  DOCX: { bg: "#EFF6FF", fg: "#1D4ED8", bd: "#93C5FD" },
  JPG: { bg: "#F0FDF4", fg: "#15803D", bd: "#86EFAC" },
  JPEG: { bg: "#F0FDF4", fg: "#15803D", bd: "#86EFAC" },
  PNG: { bg: "#F0FDF4", fg: "#15803D", bd: "#86EFAC" },
  WEBP: { bg: "#F0FDF4", fg: "#15803D", bd: "#86EFAC" },
  MP4: { bg: "#F5F3FF", fg: "#6D28D9", bd: "#C4B5FD" },
  LINK: { bg: "#F0FDFA", fg: "#0F766E", bd: "#99F6E4" },
};

export default function FileBadge({ type, className = "" }) {
  const label = fileTypeLabel(type);
  const s = MAP[label] || { bg: "#F3F4F6", fg: "#374151", bd: "#D1D5DB" };
  return (
    <span
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-[10px] font-bold tracking-wider ${className}`}
      style={{ background: s.bg, color: s.fg, borderColor: s.bd }}
    >
      {label}
    </span>
  );
}
